export default "__VITE_ASSET__CmI4mD_a__"